import { Select } from "antd";
import React from "react";

const DropDown = ({ defaultValue, options, handleSelect, width, name, value }) => {
  return (
    <Select
      defaultValue={defaultValue}
      style={{ width: width }}
      options={options}
      onChange={(value) => handleSelect(name, value)}
      value={value}
    />
  );
};

export default DropDown;
